export const parseJwt = (token) => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }
    
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    const decoded = JSON.parse(jsonPayload);
    return decoded;
  } catch (_e) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  try {
    const decoded = parseJwt(token);
    if (!decoded || !decoded.exp) {
      return true;
    }
    
    const expirationTime = decoded.exp * 1000;
    const currentTime = Date.now();
    const isExpired = currentTime >= expirationTime;
    
    return isExpired;
  } catch (_e) {
    return true;
  }
};

// Проверка, истекает ли токен скоро (за 5 минут до истечения)
export const isTokenExpiringSoon = (token) => {
  try {
    const decoded = parseJwt(token);
    if (!decoded || !decoded.exp) {
      return true;
    }
    
    const expirationTime = decoded.exp * 1000;
    const currentTime = Date.now();
    const timeUntilExpiry = expirationTime - currentTime;
    
    // Если до истечения меньше 5 минут, считаем что токен скоро истечет
    return timeUntilExpiry > 0 && timeUntilExpiry < 300000;
  } catch (_e) {
    return true;
  }
}; 